'use strict'
var service = angular.module("servicesModule",[
	'ngResource'
	]);

require('./services/jQueryService.js')(service);
// require('./services/socketService.js')(service);
require('./services/getConfigDataService.js')(service);
require('./services/authtokenService.js')(service);
require('./services/serverErrorService.js')(service);
require('./services/offlineErrorService.js')(service);
require('./services/alertService.js')(service);
require('./services/warningAlertService.js')(service);
require('./services/refreshtokenService.js')(service);
require('./services/postDataService.js')(service);
require('./services/getDataService.js')(service);
require('./services/putDataService.js')(service);
require('./services/deleteDataService.js')(service);
require('./services/authInterceptor.js')(service);
require('./services/reqursiveService.js')(service);
require('./services/activeClassService.js')(service);
require('./services/navigationService.js')(service);
require('./services/cleanObjService.js')(service);
require('./services/cleanArrayService.js')(service);
require('./services/reverseWpautopService.js')(service);
require('./services/keyPressService.js')(service);
require('./services/keyPressOnlyNumberService.js')(service);
require('./services/keyPressOnlyNumberAndDotService.js')(service);
require('./services/keyPressOnlyNumberAndEnterService.js')(service);
require('./services/keyPressSlugifyService.js')(service);
require('./services/slugifyValidatorService.js')(service);
require('./services/comunicateBetweenViewsService.js')(service);
require('./services/checkArrayService.js')(service);
require('./services/elasticSearchService.js')(service);
require('./services/escapeElasticService.js')(service);
require('./services/durationFormatedService.js')(service);
require('./services/createRandomHashService.js')(service);
require('./services/addToOtherService.js')(service);
require('./services/addToOtherByUrlService.js')(service);
require('./services/removeFromOtherService.js')(service);
require('./services/getIspTitleService.js')(service);
require('./services/downloadPdfService.js')(service);
require('./services/watchAllCheckboxesNgTableService.js')(service);
require('./services/parseOptionsService.js')(service);
require('./services/highlightWordsService.js')(service);
require('./services/cyrilicToLatinService.js')(service);
// require('./services/socketNewsService.js')(service);
require('./services/getSubstringBetweenService.js')(service);
require('./services/getMicrositesBaseOnUrlService.js')(service);
require('./services/fileReaderImageService.js')(service);
require('./services/downloadImageService.js')(service);
require('./services/copyLinkService.js')(service);
require('./services/editorExludeShortcodeServices.js')(service);
require('./services/aiModalService.js')(service);
require('./services/stripHtmlService.js')(service);
require('./services/jwtDecoderService.js')(service);
require('./services/eventStreamService.js')(service);
require('./services/tabSessionService.js')(service);
require('./services/countCharactersService.js')(service);


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/servicesModule.js
// module id = 579
// module chunks = 0